import { logError } from '../hooks/useLogger';

export default {
  install: (app) => {
    function showError({ error, text }: { error?: Error; text: string }) {
      error && logError(error, text);

      const content = [text, error && `[${error.toString()}]`].filter(Boolean);

      app._context.provides.$swal('FEHLER', content, 'error');
    }

    app.config.globalProperties.$appMessage = {
      showError,
      catchError(text: string) {
        return (error: Error) => showError({ error, text });
      },
    };
  },
};
